module.exports = __webpack_public_path__ + "static/media/mute.ea245c9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/mute.svg
// module id = 49
// module chunks = 0